// Permission names mirror what nemo-auth returns from `getPermissions`.
// These must match tide's `PermissionType` so a shell-rendered sidebar
// item gates on the same name as the equivalent tide page.
export const PermissionType = {
  Map: "MAP_PAGE",
  Goals: "GOALS_PAGE",
  Calendar: "CALENDAR_PAGE",
  AlgaeDashboard: "ALGAE_DASHBOARD",
  Data: "DATA_PAGE",
  Dashboard: "DASHBOARD_PAGE",
  Live: "LIVE_PAGE",
  Feed: "FEED_PAGE",
  Camera: "CAMERA_PAGE",
  Automation: "AUTOMATION_FORMS",
  Video: "VIDEO_PAGE",
  Feeding: "FEEDING_PAGE",
  Biomass: "BIOMASS_PAGE",
  CameraCsv: "SUPPORT_PAGE_CAMERA_CSV",
  WeeklyOptimization: "WEEKLY_OPTIMIZATION",
  Admin: "ADMIN_PAGE",
  Support: "SUPPORT_PAGES",
  GoalsConfiguration: "GOALS_CONFIGURATION",
  AkvaAnalytics: "ACVA_CONTROL_ANALYTICS",
  Plan: "PLAN_PAGE",
  ReadManagerApi: "READ_MANAGER_API",
  IsCompanyAdmin: "IS_COMPANY_ADMIN",
  IsASiteFarmer: "IS_A_SITE_FARMER",
} as const;

export type PermissionTypeValue =
  (typeof PermissionType)[keyof typeof PermissionType];
